import { useTranslation } from 'react-i18next';
import Card from '../Card';
import GhostButton from '../GhostButton';
import ChartIcon from '../icons/ChartIcon';
import { DialogIcon } from './EntryWindow';

// SCR-03: the investor's country has no planner (AC-30). No numbers, one way out.
function PlannerUnavailable({ onToCalculation }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <p className="text-[11px] font-semibold uppercase tracking-[.06em] text-text-muted">{t('taxPlanner.unavailable.eyebrow')}</p>
      <h1 className="mt-1.5 text-2xl font-semibold tracking-[-.02em] text-text">{t('taxPlanner.page.title')}</h1>
      <Card className="mt-[22px] flex max-w-xl flex-col items-start gap-4 p-7">
        <DialogIcon>
          <ChartIcon />
        </DialogIcon>
        <h2 className="text-xl font-semibold leading-[1.3] tracking-[-.01em] text-text">{t('taxPlanner.unavailable.title')}</h2>
        <p className="text-sm text-text-muted">{t('taxPlanner.unavailable.text')}</p>
        <GhostButton size="lg" onClick={onToCalculation}>
          {t('taxPlanner.unavailable.toCalculation')}
        </GhostButton>
      </Card>
    </div>
  );
}

export default PlannerUnavailable;
